/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedultrainingoscompanion6Inputs */

const de__field_participatedultrainingoscompanion6 = /** @type {(inputs: _Field_Participatedultrainingoscompanion6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Training OSCompanion`)
};

/**

* @param {_Field_Participatedultrainingoscompanion6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedultrainingoscompanion6 = /** @type {((inputs?: _Field_Participatedultrainingoscompanion6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedultrainingoscompanion6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedultrainingoscompanion6(inputs)
});
export { _field_participatedultrainingoscompanion6 as "_field_participatedULTrainingOSCompanion" }